import styled from "styled-components";

export const TournamentStateWrapper = styled.div<{
  isApp: null | number;
  reservation: boolean;
}>`
  position: relative;
  height: 100%;
  background: white;
  overflow: auto;
  top: ${(p) => (p.isApp ? `${p.isApp}px` : "0")};

  > .inner {
    margin-top: ${(p) => (p.reservation ? "0" : "68px")};

    > .content {
      position: relative;
    }
  }
`;

export const TournamentStateHeader = styled.div<{ isApp: null | number }>`
  z-index: 101;
  transition: all 0.1s ease-in-out;
  top: 0;
  position: fixed;
  max-width: 500px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
  gap: 8px;
  background-color: white;
  padding-top: ${(p) => (p.isApp ? `${p.isApp + 12}px` : "0")};
  padding-bottom: ${(p) => (p.isApp ? `${24}px` : "0")};
  .close {
    cursor: pointer;
    width: 24px;
    height: 24px;

    svg path {
      stroke: var(--Black-400, #444);
    }
  }

  .title {
    font-weight: 600;
    font-size: 16px;
  }
`;

export const TournamentBackgroundImage = styled.div`
  width: 100%;
  height: 324px;
  overflow: hidden;
  > img {
    width: 100%;
    object-fit: cover;
  }
`;

export const TournamentContent = styled.div<{ isReservation: boolean }>`
  position: absolute;
  top: ${(p) => (p.isReservation ? "-83px" : 0)};
  width: 100%;
  padding-bottom: 100px;
`;

export const TournamentStateNoticeWrapper = styled.div`
  margin: 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  > .header {
    font-weight: 700;
    font-size: 20px;
  }
`;

export const TournamentStateNoticeBack = styled.div<{ more: boolean }>`
  background: var(--Black-100, #f0f0f0);
  width: 100%;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  gap: 16px;
  align-items: flex-start;

  > .content {
    font-weight: 400;
    font-size: 13px;
    ${(p) =>
      p.more
        ? ""
        : `
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    `}
  }
`;
